import { push } from "connected-react-router";
import React, { useEffect, useState } from "react";
import { APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, ROUTE_PATH } from "../../app/constants";
import { useDispatch, useSelector } from "react-redux";
import { ValidateString } from "../../app/utils";
import { Button, ErrorMark } from "../../components/RegularComponents";
import {
  ERROR_STRING,
  VALIDATION_TYPE,
  VALIDATION_ERROR,
  phoneNumberErrorString,
  emailErrorString,
} from "../../app/errors";
// import { ERROR_STRING } from "../../app/errors";

import { ErrorWithString } from "../../components/RegularComponents";
import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";
import TopNavigationBar from "../TopNavigationBar";
import styles from "./mra.module.scss";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";

const MORTGAGE_APPLICATION_PROPERTY = "mainBusinessContact";
export const CompanyContactInformation = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();

  const applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
  const applicationMode = APPLICATION_MODE_NEW

  const mainBusinessContact = useSelector(
    (state) => state.primaryAgencyApplication.application.businessLicenceData.mainBusinessContact 
  );

  const [phone, setPhone] = useState(mainBusinessContact.phoneNumber);
  const [phoneError, setPhoneError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [email, setEmail] = useState(mainBusinessContact.emailAddress);
  const [emailError, setEmailError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [showValidationError, setShowValidationError] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false)

  useEffect(() => {
    phoneError === VALIDATION_ERROR.NO_ERROR &&
    emailError === VALIDATION_ERROR.NO_ERROR
      ? setShowValidationError(false)
      : setShowValidationError(true);
  }, [phoneError, emailError]);

  const validateData = () => {
    const ret1 = ValidateString(phone, VALIDATION_TYPE.PHONE_NUMBER);
    setPhoneError(ret1);

    const ret2 = ValidateString(email, VALIDATION_TYPE.EMAIL);
    setEmailError(ret2);

    return (
      ret1 === VALIDATION_ERROR.NO_ERROR && 
        ret2 === VALIDATION_ERROR.NO_ERROR
    );
  };

  const handleSave = () => {
    //reset errors
    setShowValidationError(false);
    setPhoneError(VALIDATION_ERROR.NO_ERROR);
    setEmailError(VALIDATION_ERROR.NO_ERROR);

    if (!validateData()) {
      setShowValidationError(true);
      return false;
    }

    const update = {
      key: MORTGAGE_APPLICATION_PROPERTY,
      value: {
        ...mainBusinessContact,
        phoneNumber: phone,
        emailAddress : email
      }
    };
    dispatch(setMortgageProperty(update));

    return true
  }

  const handleNext = () => {
    if (handleSave()) {
      dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
      .then(data => {
        dispatch(
          push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_COMPANY_FINANCIAL_LOCATION}`)
        );
      })
      .catch(err => {
        setApplicationSaveError(true)
      })
    }
  };

  const handleSaveandClose = () => {
    if (handleSave()) {
      onEditSave();
    }
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    setPhoneError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(VALIDATION_ERROR.NO_ERROR);
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          <TopNavigationBar {...props} />
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <h1>Company's Contact Information</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-lg-8">
            Enter your company’s contact information that will be listed on the public register of mortgage brokers in Nova Scotia.
            </div>
          </div>
        </>
      )}

      {/* Phone */}
      <div style={{ marginTop: "30px" }} className="row">
        <div className="col-lg-8">
          <div className={
            "ns-fieldset" +
            ((phoneError !== VALIDATION_ERROR.NO_ERROR)
              ? " has-error ns-fieldset-message-error"
              : "")
          }>
          <fieldset className="ns-fieldset">
            <label
              id={"mortgage-broker-licence-number-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"mortgage-broker-licence-number-text"}
            >
              Phone
            </label>
            {phoneError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"mortgage-broker-licence-number-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(phoneNumberErrorString(phoneError))}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (phoneError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"mortgage-broker-licence-number-text"}
              name={"mortgage-broker-licence-number-text"}
              value={phone}
              onChange={handlePhoneChange}
            />
          </fieldset>
          </div>
        </div>
      </div>

      {/* Email */}
      <div className="row">
        <div className="col-lg-8">
          <div className={
            "ns-fieldset" +
            ((emailError !== VALIDATION_ERROR.NO_ERROR)
              ? " has-error ns-fieldset-message-error"
              : "")
          }>
          <fieldset className="ns-fieldset">
            <label
              id={"mortgage-broker-licence-number-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"mortgage-broker-licence-number-text"}
            >
              Email
            </label>
            {emailError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"mortgage-broker-licence-number-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(emailErrorString(emailError))}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (emailError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"mortgage-broker-licence-number-text"}
              name={"mortgage-broker-licence-number-text"}
              value={email}
              onChange={handleEmailChange}
            />
          </fieldset>
          </div>
        </div>
      </div>

      {/* Save and continue */}
      <div className="row">
        <div className={"col-lg-4" + ((applicationSaveError || showValidationError) ? " has-error" : "")}>
          <Button
            className={`${styles["question_button"]} btn-lg btn-default`}
            style={{ margin: "0 10px 10px 0" }}
            buttonType={"regular_primary"}
            onClick={!isModal ? handleNext : handleSaveandClose}
            text={!isModal ? "Save and next" : "Save and close"}
          />

          {(applicationSaveError || showValidationError) && ErrorMark()}
          {showValidationError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.CHECK_FIELDS}
            </div>
          )}
          {applicationSaveError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
